module.exports = __webpack_public_path__ + "pc/img/img3.4f133bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/head/img3.png
// module id = aKwP
// module chunks = 3